import React, { FunctionComponent, useState, ReactNode } from "react";

import {
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select
} from "@material-ui/core";
import { AppState } from "../../store";

import { useSelector } from "react-redux";
import { thunkFetchSegments } from "../../store/segments/actions";
import { Segment } from "../../models/Segment";
import { asList, useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";

interface Props {
  selectedSegments?: string[];
  onSelectedSegment: (storeId: string[]) => void;
}
interface State {
  selectedSegmentIds: string[];
}

export const SegmentMultiSelect: FunctionComponent<Props> = ({
  selectedSegments,
  onSelectedSegment
}) => {
  const segments = asList<Segment>(
    useSelector<AppState, unknown>(s => s.segments)
  );

  const [state, setState] = useState<State>({
    selectedSegmentIds: selectedSegments || []
  });

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const selectedSegements = event.target.value as string[];
    setState({ selectedSegmentIds: selectedSegements });
    onSelectedSegment(selectedSegements);
  };

  const renderNames = (segmentIds: ReadonlyArray<string>): ReactNode => {
    return segments
      .filter(segment => segmentIds.includes(segment.id))
      .map(segment => segment.name)
      .join(", ");
  };

  useLoadIfEmpty(!segments.length, thunkFetchSegments);

  return (
    <>
      <FormControl>
        <InputLabel id="demo-mutiple-checkbox-label">Selected</InputLabel>
        <Select
          style={{ width: 300 }}
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          autoWidth
          value={state.selectedSegmentIds}
          onChange={handleChange}
          input={<Input />}
          renderValue={selected => renderNames(selected as string[])}
        >
          {segments.map(segment => (
            <MenuItem key={segment.id} value={segment.id}>
              <Checkbox
                checked={state.selectedSegmentIds.indexOf(segment.id) > -1}
              />
              <ListItemText primary={segment.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
